// Fixed favicons of the crawled engines: the same Google favicon service URLs as before,
// without building them from the engine name.
const ENGINE_ICON_URLS: Record<string, string | undefined> = {
  GOOGLE:
    'https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.google.com&size=64',
  BING: 'https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://www.bing.com&size=64',
}

export function getEngineIconUrl(engine?: string | null): string | undefined {
  return engine ? ENGINE_ICON_URLS[engine.toUpperCase()] : undefined
}
